export enum FlexFit {
  loose,
  tight
}
